import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService, OperatorService, UserService} from "../services";
import {Subject} from "rxjs";
import {locale as polish} from "../order/i18n/pl";
import {locale as english} from "../order/i18n/en";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {OrderService} from "../services/order.service";
import {Orders} from "../models/orders";
import {first} from "rxjs/operators";
import {Items} from "../models/items";
import {Page} from "../models/page";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DateRange} from "../models/dateRange";
import {ActivatedRoute} from "@angular/router";

@Component({
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    range = new FormGroup({
        start: new FormControl(),
        end: new FormControl()
    });
    dateRangeForm: FormGroup;
    dateRange: DateRange;
    userId: string;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private orderService: OrderService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Orders');
    }

    ngOnInit() {
        if (this.route.snapshot.params['userId']) {
            this.userId = this.route.snapshot.params['userId'];
        }

        this.dateRangeForm = this.formBuilder.group({
            fromDate: new FormControl('', Validators.required),
            toDate: new FormControl('', Validators.required)
        });

        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        let filters = {"dateRange": {"startDate": null, "endDate": null}, "customer": null};

        if (typeof this.dateRange !== "undefined") {
            filters = {
                'dateRange': {
                    'startDate': this.dateRange.startDate,
                    'endDate': this.dateRange.endDate,
                },
                'customer': null
            };
        }

        if (this.userId) {
            filters.customer = this.userId;
        }

        this.orderService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit, filters).pipe(first())
            .subscribe((res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    onFormSubmit() {
        console.log('Is Form Invalid', this.dateRangeForm.invalid);
    }

    filterByDateRange(range: DateRange) {
        this.dateRange = range;
        this.setPage({offset: 0});
    }
}
